export default __webpack_public_path__ + "static/media/G_EVOLUTION_IMG.d511aa3d.jpg";